/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var draggable_directive_1 = require("./draggable.directive");
var common_1 = require("@angular/common");
/**
 * @hidden
 */
var DraggableModule = /** @class */ (function () {
    function DraggableModule() {
    }
    DraggableModule = tslib_1.__decorate([
        core_1.NgModule({
            declarations: [draggable_directive_1.DraggableDirective],
            exports: [draggable_directive_1.DraggableDirective],
            imports: [common_1.CommonModule]
        })
    ], DraggableModule);
    return DraggableModule;
}());
exports.DraggableModule = DraggableModule;
